import { render, staticRenderFns } from "./type-statistics.vue?vue&type=template&id=09bef884&scoped=true&"
import script from "./type-statistics.vue?vue&type=script&lang=js&"
export * from "./type-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bef884",
  null
  
)

export default component.exports